export const CALENDAR_MOBILE_WIZARD_TOTAL_STEPS = 4

export const CALENDAR_MOBILE_DURATION_OPTIONS: Array<{
  value: number
  label: string
}> = [
  { value: 10, label: 'calendar.up_to_10min' },
  { value: 20, label: 'calendar.up_to_20min' },
  { value: 30, label: 'calendar.up_to_30min' },
  { value: 60, label: 'calendar.up_to_1h' },
  { value: 90, label: 'calendar.up_to_1h30min' },
  { value: 120, label: 'calendar.up_to_2h' },
  { value: 150, label: 'calendar.up_to_2h30min' },
  { value: 180, label: 'calendar.up_to_3h' },
  { value: 240, label: 'calendar.up_to_4h' },
  { value: 300, label: 'calendar.up_to_5h' },
]
